export default __webpack_public_path__ + "static/media/linux.044f543b.svg";